import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import styles from "./Pagination.module.scss";
import { scrollToTop } from "../CommonMethods";

function CommonPagination({ pagination_meta, params, setParams }) {
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    if (pagination_meta) {
      setPageNumber(pagination_meta.current_page - 1 || 0);
    }
  }, [pagination_meta]);

  if (!pagination_meta || pagination_meta.pages <= 1) {
    return null;
  }

  const pageCount = pagination_meta.pages;

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setPageNumber(selectedPage);
    setParams((prevParams) => ({
      ...prevParams,
      page: selectedPage + 1,
    }));
    scrollToTop();
  };

  return (
    <div className={styles.paginationContainer}>
      <ReactPaginate
        breakLabel="..."
        nextLabel={pageNumber < pageCount - 1 ? "Next" : null}
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel={pageNumber > 0 ? "Back" : null}
        marginPagesDisplayed={2}
        containerClassName={styles.pagination}
        activeClassName={styles.active}
        forcePage={pageNumber}
      />
    </div>
  );
}

export default CommonPagination;
